import { useMemo, useState } from 'react';
import { formatAmount } from '../../../../utils/appointments/formatAmount';

export function usePaymentAmountData(formatMessage, value) {
  const [editMode, setEditMode] = useState(false);
  const [errorState, setError] = useState(false);

  const safeValue = value ? formatAmount(value) : formatAmount(0);
  const [currentValue, setCurrentValue] = useState(safeValue);

  const isPristine = currentValue === safeValue;

  const handleCopayChange = (amountValue, err) => {
    setError(err);
    setCurrentValue(amountValue);
  };

  const handleToInitialState = () => {
    setCurrentValue(safeValue);
    setEditMode(false);
  };

  const handleToggleEditState = () => {
    setEditMode(!editMode);
    setCurrentValue(safeValue);
  };

  return useMemo(
    () => ({
      editMode,
      errorState,
      handleCopayChange,
      handleToInitialState,
      handleToggleEditState,
      safeValue,
      isPristine,
      currentValue,
    }),
    [
      editMode,
      errorState,
      handleCopayChange,
      handleToInitialState,
      handleToggleEditState,
      safeValue,
      isPristine,
      currentValue,
    ],
  );
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/PaymentAmountField/usePaymentAmountData.js